import { FPADataQuery_search_Search_advert_Advert as Advert } from "../../connected-components/hoc/query/__generated__/fpa-page-data.query";

interface AdvertValidPrice extends Advert {
  price: number;
}

export enum DealBuilderTabs {
  BUY,
  FINANCE,
}

export const dealBuilderId = "deal-builder";
export const dealBuilderTabId = "db-tab";

export const getDataGuiPrefixedValue = (value: string): string => {
  return `db-${value}`;
};
export const getDataTestIdPrefixedValue = (value: string): string => {
  return `db-${value}`;
};

export const getDefaultDealBuilderTab = (
  advert: Advert,
  hash: string,
): DealBuilderTabs => {
  if (
    !advert.isFinanceAvailable ||
    hash.includes(`${dealBuilderTabId}-1`) ||
    hash.includes(`${dealBuilderId}-total-price`)
  ) {
    return DealBuilderTabs.BUY;
  }

  return DealBuilderTabs.FINANCE;
};

export const hasValidAdvertPrice = (
  advert: Advert,
): advert is AdvertValidPrice => {
  return typeof advert.price === "number";
};
